"use strict";

exports.__esModule = true;
exports.readToBuffer = void 0;

exports.readToBuffer = function (file) {
  return new Promise(function (res, rej) {
    var reader = new FileReader();
    reader.addEventListener('load', function () {
      if (reader.result === null) {
        rej('Result is null.');
      }

      var result = reader.result;

      if (result.length === 0) {
        return res(Buffer.from(''));
      }

      return res(Buffer.from(result, 'binary'));
    });
    reader.readAsBinaryString(file);
  });
};